import { useTranslation } from 'react-i18next';
import { Typography } from '@heroui/react';
import { Icon } from '@iconify/react';

type TransactionDiscountNoteProps = { note: string };
export const TransactionDiscountNote = ({
    note,
}: TransactionDiscountNoteProps) => {
    const { t } = useTranslation('pages');
    return (
        <Typography
            type="body-xs"
            color="muted"
            className="mt-1 flex items-start gap-1"
        >
            <Icon
                aria-hidden="true"
                icon="gravity-ui:comment"
                className="mt-0.5 size-3 shrink-0"
            />
            <span className="min-w-0 wrap-anywhere">
                {t('sales.widgets.transactions.modal.note', { note })}
            </span>
        </Typography>
    );
};
